import React from "react";
import NoResults from "../../../../components/noResults/NoResults";
import NoSearchResults from "../../../../components/noSearchResults";

export type AccountsNoResultsProps = {
  filtered: boolean;
  canCreate: boolean;
  renderCreateAccountButton?(): React.ReactNode;
};

const AccountsNoResults: React.FC<AccountsNoResultsProps> = ({ filtered, canCreate, renderCreateAccountButton }) =>
  filtered ? (
    <NoSearchResults />
  ) : (
    <NoResults
      title="You don't have any accounts."
      description={`Looks like you don't have any accounts yet.${canCreate ? " Create some now using the button below." : ""}`}
      iconClassName="building"
    >
      {canCreate && !!renderCreateAccountButton && renderCreateAccountButton()}
    </NoResults>
  );

export default AccountsNoResults;
